module.exports = __webpack_public_path__ + "static/media/gmail.1b4ab7bb.svg";